// extracted by mini-css-extract-plugin
export default {"image":"DZ-z","loaded":"EZ-z"};